import React from 'react';
import { modelClass } from '/imports/api/priceSources';
import { ModelFormPage } from '/imports/ui/ModelFormPage';

export const PriceSourcePage = () => (
  <ModelFormPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    formSpec={() => [[{ field: 'type', label: 'Type' }], [{ field: 'url', label: 'URL' }]]}
  />
);
